import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { HANDOVER_STATUS_ACCEPTED } from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import { Profile } from 'src/app/interfaces/profile';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SectionTouched } from '../shared/section-touched.class';

@Component({
  selector: 'app-handover-detail-profiles',
  templateUrl: './handover-detail-profiles.component.html',
  styleUrls: ['./handover-detail-profiles.component.scss'],
  standalone: false,
})
export class HandoverDetailProfilesComponent
  extends SectionTouched
  implements OnInit
{
  @Input() handover: Handover | undefined;
  @Input() readOnlyContent!: boolean;

  profiles: Profile[] = [];
  isLoadingProfiles = false;
  showFooterNoDataOrign = false;

  displayedColumns = [
    'wellboreNo',
    'holeSize',
    'fecha',
    'jobType',
    'service',
    'mdTop',
    'mdBase',
    'actions',
  ];
  hideFooter = true;

  originalProfiles: Profile[] = [];
  isDisabled: boolean[] = [];

  constructor(
    public handoverService: HandoverService,
    private notificationService: NotificationService,
    public dialogService: DialogService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.handover) {
      this.setProfileDataSource();
      this.showFooterNoDataOrign =
        this.handover.handoverStatusId != HANDOVER_STATUS_ACCEPTED;
    }
  }

  setProfileDataSource(): void {
    this.isLoadingProfiles = true;
    this.handoverService
      .getProfiles(
        this.handover!.handoverId,
        this.handover!.wellId,
        this.handover!.handoverStatusId,
        this.handover!.handoverTypeId
      )
      .subscribe((p: Profile[]) => {
        this.profiles = p;
        this.isLoadingProfiles = false;
        this.hideFooter = p.length > 0;
        this.setOriginalProfilesValues(p);
      });
  }

  setOriginalProfilesValues(profiles: Profile[]): void {
    profiles.map((val) => {
      if (val.comments == null) val.comments = '';
      this.originalProfiles.push(Object.assign({}, val));
      this.isDisabled.push(true);
    });
  }

  save(profile: Profile, index: number): void {
    this.dialogService
      .openConfirmDialog('Perfiles', '¿Desea guardar los cambios en el Perfil?')
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          profile.handoverId = this.handover!.handoverId;
          const profiles: Profile[] = [];
          profiles.push(profile);

          this.handoverService
            .saveProfiles(profiles)
            .subscribe((savedProfiles: Profile[]) => {
              if (savedProfiles) {
                this.notificationService.notify(
                  'Perfil guardado satisfactoriamente',
                  true
                );
                this.isDisabled[index] = true;
                this.originalProfiles[index].holeSize = profile.holeSize;
                this.originalProfiles[index].comments = profile.comments;
                this.reportPendingChanges();
              } else {
                this.notificationService.notify(
                  'Ocurrió un error al guardar el Perfil',
                  false
                );
              }
            });
        }
      });
  }

  openComments(
    profile: Profile | undefined,
    index: number,
    event: any,
    readOnly: boolean
  ) {
    const target = new ElementRef(event.currentTarget);
    this.dialogService
      .openCommentDialog(
        'Comentar profundidad, presión etc.',
        profile?.comments,
        target,
        -200,
        -450,
        readOnly
      )
      .afterClosed()
      .subscribe((comments: string) => {
        this.profiles[index].comments = comments;
        this.enableSaveButton(
          index,
          comments,
          String(this.profiles[index].holeSize)
        );
      });
  }

  enableSaveButton(
    index: number,
    comments: string | undefined,
    holeSize: string
  ) {
    const enable =
      comments != this.originalProfiles[index].comments ||
      String(holeSize).trim() !=
        String(this.originalProfiles[index].holeSize).trim();
    this.isDisabled[index] = !enable;
    this.reportPendingChanges();
  }

  reportPendingChanges(): void {
    let thereAreChanges = false;
    for (let index = 0; index < this.profiles.length; index++) {
      thereAreChanges =
        thereAreChanges ||
        this.profiles[index].comments !=
          this.originalProfiles[index].comments ||
        String(this.profiles[index].holeSize) !=
          String(this.originalProfiles[index].holeSize);
    }
    this.emitPendingChanges(thereAreChanges);
  }
}
